import { OdataManager } from '@/api/odata/odata-manager';
import { TitleObject } from '@/api/model/interfaces';

export default class TitleObjectOdata extends OdataManager<TitleObject> {}
